import { createContext, type ReactNode, useContext } from "react";

const BrandColorContext = createContext<string | null>(null);

export function BrandColorProvider({
  color,
  children,
}: {
  color: string | null | undefined;
  children: ReactNode;
}) {
  return <BrandColorContext.Provider value={color ?? null}>{children}</BrandColorContext.Provider>;
}

/** Returns the tenant brand color as a hex string, or null if not set. */
export function useBrandColor(): string | null {
  return useContext(BrandColorContext);
}
